const regions = [
  { name: 'Guadeloupe' },
  { name: 'Martinique' },
  { name: 'Guyane' },
  { name: 'La R\u00e9union' },
  { name: 'Mayotte' },
  { name: '\u00cele-de-France' },
  { name: 'Centre-Val de Loire' },
  { name: 'Bourgogne-Franche-Comt\u00e9' },
  { name: 'Normandie' },
  { name: 'Hauts-de-France' },
  { name: 'Grand Est' },
  { name: 'Pays de la Loire' },
  { name: 'Bretagne' },
  { name: 'Nouvelle-Aquitaine' },
  { name: 'Occitanie' },
  { name: 'Auvergne-Rh\u00f4ne-Alpes' },
  { name: "Provence-Alpes-C\u00f4te d'Azur" },
  { name: 'Corse' },
  { name: "Collectivit\u00e9s d'Outre-Mer" }
];
export default regions;
